import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { externalLinks } from '../data/mock';
import { Star, ExternalLink } from 'lucide-react';

const SocialProof = () => {
  const { t } = useLanguage();

  return (
    <section className="bg-black py-8 border-y border-white/10">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Stats */}
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
            <div className="flex items-center gap-2">
              <div className="flex text-yellow-400">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={18} fill="currentColor" />
                ))}
              </div>
              <span className="text-white/90 text-sm">{t('naverRating')}</span>
            </div>
            <div className="text-white/60 text-sm">{t('realReviews')}</div>
            <div className="text-white/60 text-sm">{t('returning')}</div>
          </div>
          
          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a
              href={externalLinks.naverPlace}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 border border-white/20 text-white/80 hover:text-white hover:border-white text-sm transition-all"
              style={{ borderRadius: 0 }}
            >
              {t('viewNaverReviews')}
              <ExternalLink size={14} />
            </a>
            <a
              href={externalLinks.naverMapReview}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 border border-[#00FFD1]/50 text-[#00FFD1] hover:bg-[#00FFD1] hover:text-black text-sm transition-all"
              style={{ borderRadius: 0 }}
            >
              {t('viewBlogReviews')}
              <ExternalLink size={14} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;